import { createContext, useContext, useEffect, useState } from "react";
import { pendingCount, subscribe, flush } from "@/lib/offlineQueue";

const SyncContext = createContext(null);

export const SyncProvider = ({ children }) => {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(0);
  const [lastSyncedAt, setLastSyncedAt] = useState(null);

  const refreshPending = async () => {
    try { setPending(await pendingCount()); } catch (_e) { /* ignore — sync counter is best-effort */ }
  };

  useEffect(() => {
    refreshPending();
    const unsub = subscribe(refreshPending);
    const on = () => {
      setOnline(true);
      setLastSyncedAt(new Date());
      // aggressively try to drain the queue on reconnect
      flush();
      setTimeout(flush, 1000);
      setTimeout(flush, 3000);
    };
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      unsub();
    };
  }, []);

  const state = !online ? "offline" : pending > 0 ? "syncing" : "synced";
  return (
    <SyncContext.Provider value={{ online, pending, refreshPending, lastSyncedAt, state, flush }}>
      {children}
    </SyncContext.Provider>
  );
};

export const useSync = () => useContext(SyncContext);
